import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { InvoiceIntegrationModel } from './InvoiceIntegrationModel';
export class InvoiceAccountingIntegration {
    static fromDTO(dto) {
        return new InvoiceAccountingIntegration(InvoiceIntegrationModel.fromScoutDTO(dto.integration), dto.isSync);
    }
    isSynced() {
        return this.integration.isSynced() && this.isSync;
    }
    isRefundRecorded() {
        return this.integration.isRefundRecorded();
    }
    isPaymentRecorded() {
        return this.integration.isPaymentRecorded();
    }
    getIntegration() {
        return this.integration;
    }
    setIntegration(integration) {
        this.integration = integration;
    }
    setIsSync(isSync) {
        this.isSync = isSync;
    }
    constructor(integration, isSync){
        _define_property(this, "integration", void 0);
        _define_property(this, "isSync", void 0);
        this.integration = integration;
        this.isSync = isSync;
    }
}
